module.exports = __webpack_public_path__ + "static/media/card (1).8cafd055.pdf";